import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

export const useModalStore = defineStore('modal', {
    state: () => ({
        isOpen: false,
        name: '',
        size: '',
        fixSize: '',
        title: '',
        content: '',
        iconName: '',
        data: {},

        // for promise-based modals (confirm-action-modal)
        pendingPromise: null,
        lastResult: null,
    }),

    getters: {},

    actions: {
        setOpen({ name, size, fixSize = '', title, content, iconName, data }) {
            this.isOpen = true
            this.name = name
            this.size = size
            this.fixSize = fixSize
            this.title = title
            this.content = content
            this.iconName = iconName
            this.data = data
        },

        setOpenWithPromise({ name, size, fixSize = '', title, content, iconName, data }) {
            return new Promise((resolve, reject) => {
                this.pendingPromise = resolve
                this.setOpen({
                    name,
                    size,
                    fixSize: fixSize,
                    title,
                    content,
                    iconName,
                    data: {
                        ...data,
                        onConfirm: () => {
                            this.lastResult = true
                            resolve(true)
                        },
                        onCancel: () => {
                            this.lastResult = false
                            resolve(false)
                        },
                    },
                })
            })
        },

        setClose() {
            if (this.pendingPromise) {
                this.lastResult = false
                this.pendingPromise(false)
                this.pendingPromise = null
            }

            this.isOpen = false
            this.name = ''
            this.size = ''
            this.fixSize = ''
            this.title = ''
            this.content = ''
            this.iconName = ''
            this.data = {}
        },

        async confirm({ title, content, buttonLabel = 'Confirm' }) {
            return this.setOpenWithPromise({
                name: 'ConfirmActionModal',
                title: title || 'Please confirm',
                data: {
                    type: 'confirm',
                    content,
                    buttonLabel,
                },
            })
        },

        async confirmDelete({ title, content, buttonLabel = 'Delete' }) {
            return this.setOpenWithPromise({
                name: 'ConfirmActionModal',
                title: title || 'Confirm deletion',
                data: {
                    type: 'delete',
                    content,
                    buttonLabel,
                },
            })
        },
    },
})
